import { AsyncDataGrid } from "src/components/common/dataGrid/AsyncDataGrid";
import { TestConfigurationResultViewCommonProps } from "../TestConfigurationResultViewCommonProps";
import {
	TestConfigurationAttributesApi,
	TestConfigurationAttributesApi_Row,
} from "src/api/generated/erp/configurator/api/configuratorTesting/testConfigurationAttributesApi.ts";
import i18n from "i18next";
import { dataGridPersistentStateProps } from "src/components/common/dataGrid/dataGridStateStorage.ts";
import {
	attributeValueToUserFriendlyString,
	decodeObjectAttributeValue,
} from "src/components/views/erp/objectAttributes/objectAttributeValueConverting.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export const TestConfigurationAttributeResultsDataGrid = ({
	configurationSessionId,
	configuratorType,
	propertyValues,
}: TestConfigurationResultViewCommonProps) => {
	return (
		<AsyncDataGrid<TestConfigurationAttributesApi_Row>
			fetchRows={() =>
				TestConfigurationAttributesApi.getTestConfigurationAttributes({
					configurationSessionId,
					configuratorType,
					propertyValues,
				})
			}
			getRowId={(row) => row.attributeField.id}
			columns={[
				{
					headerName: i18n.t("attribute"),
					field: "attribute",
					width: 120,
					valueGetter: (_, row) => row.attributeField.label,
				},
				{
					headerName: i18n.t("value"),
					field: "value",
					width: 200,
					valueGetter: (_, row) =>
						attributeValueToUserFriendlyString(
							decodeObjectAttributeValue(row.attributeValue ?? null, row.attributeField.type),
							row.attributeField.type,
						),
				},
			]}
			agentContext={{
				key: defineAgentUiContextKey("erp.configurator.testConfigurationAttributes.grid"),
				data: { configurationSessionId },
				rowFields: ["attributeField"],
				selectedRowPathSegment: (row) => row.attributeField.label,
				selectedRowsPathSegment: (count) => i18n.t("rows_selected_count", { count }),
			}}
			{...dataGridPersistentStateProps("AE602DFB73807648")}
		/>
	);
};
